<template>
	<div>

		<el-tabs  type="border-card" v-model="tabConfig" v-if="consulta">
			<el-tab-pane label="Config" name="tab-consulta">
				<span slot="label">
					<i class="fa fa-stethoscope"></i>
					Informações da Consulta
				</span>
				
				<div class="row p-1">
					<div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border border-bottom-0 border-right-0">
						<b>Cód</b>
					</div>

					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border border-bottom-0">
						{{consulta.id}}
					</div>

					<div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border border-bottom-0  border-right-0">
						<b>Funcionário</b>
					</div>

					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border border-bottom-0">
						{{consulta.funcionario.nome}}
					</div>

					<div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border border-bottom-0  border-right-0">
						<b>CPF</b>
					</div>

					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border border-bottom-0">
						{{consulta.funcionario.cpf}}
					</div>

					<div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border border-bottom-0  border-right-0">
						<b>Função</b>
					</div>

					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border border-bottom-0">
						{{consulta.funcao.nome}}
					</div>

					<div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border  border-right-0">
						<b>Tipo da Consulta</b>
					</div>

					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border">
						{{consulta.tipo_aso.descricao}}
					</div>
				</div>
				
			</el-tab-pane>

			<el-tab-pane label="Config" name="tab-consulta-exame">
				<span slot="label">
					<i class="fa fa-user-md"></i>
					Informações dos Exames
				</span>
				
				 <table class="table historico-consulta">
					<tr>
						<th style="text-align:left;font-size:7pt;background:#eeeeee">Exame</th>
						<th width="100" style="text-align:left;font-size:7pt;background:#eeeeee">Data</th>
						<th width="100" style="text-align:left;font-size:7pt;background:#eeeeee">Valor</th>
					</tr>
					<tr v-for="exame in consulta.exames" :key="exame.id">
						<td style="font-size:8pt">
							{{exame.exame.nome}}
							<span v-if="exame.id_con_rea" style="font-size:9pt;">
								<br>
								Exame reaproveitado na consulta <label style="color:red">{{exame.id_con_rea}}</label> em {{toDate(exame.data,true)}}
							</span>

							<span v-if="exame.id_con_dem" style="font-size:9pt;">
								<br>
								Exame demonstrativo na consulta <label style="color:red">{{exame.id_con_dem}}</label>
							</span>

							<span style="color:red" v-if="!exame.pcmso_exame"><br>Exame não encontrado no PCMSO</span>
						</td>
						<td style="font-size:8pt">
							{{(exame.id_con_rea ? '---' : toDate(exame.data,true))}}
						</td>
						<td style="font-size:8pt">
							{{(exame.id_con_rea ? '---' : exame.valor)}}
						</td>
					</tr>
				</table>
			</el-tab-pane>

			<el-tab-pane label="Config" name="tab-consulta-risco">
				<span slot="label">
					<i class="fa fa-exclamation-triangle"></i>
					Informações dos Riscos
				</span>
				
				<table class="table historico-consulta">
					<tr>
						<th style="text-align:left;font-size:7pt;background:#eeeeee" width="100">Categoria</th>
						<th width="100" style="text-align:left;font-size:7pt;background:#eeeeee">Risco</th>
					</tr>
					<tr v-for="risco in consulta.riscos" :key="risco.id">
						<td style="font-size:8pt">
							<span v-if="risco.risco">
								{{risco.risco.categoria.categoria}}
							</span>
							<span v-else-if="risco.categoria">
								{{risco.categoria.categoria}}
							</span>
						</td>
						<td style="font-size:8pt">
							<span v-if="risco.risco">
								{{risco.risco.nome}}
							</span>
							<span v-else-if="risco.nome">
								{{risco.nome}}
							</span>
						</td>
					</tr>
				</table>
				
			</el-tab-pane>

		</el-tabs>
		
	</div>
</template>

<script>
	
	import Fct from 'common/fct'

  	export default {
  		components: {},
		mixins:[Fct],
		props:{
			consulta:{
				type:Object,
				default:function(){return null}
			},
		},
		watch:{
			consulta(){
			},
		},
  		data () {
		   	return {
				tabConfig:'tab-consulta',
			}
		},

		created(){
		},

		mounted: function() {
		},

		methods: {

		}
  	}
</script>



// WEBPACK FOOTER //
// consulta-detalhe.vue?72f5e59c